const _state = {
  affectedApplicationData: null,
}
//{applicationId:Guid, operation:I/U} Insert o Update

export const initialState = () => _state

export const state = initialState()
